import {Repository as BaseRepository} from "@oilstone/rest-model-repository";
import Kernel from "@oilstone/kernel";
import Blender from "@oilstone/blender";

class Repository extends BaseRepository {
    static make(model, schema) {
        return new Repository(model, schema);
    }

    baseQuery() {
        const query = super.baseQuery();
        const context = Kernel.resolve('context');

        if (context && context.app === 'web') {
            if (this.schema.getProp('isPublished')) {
                query.where('isPublished', 1);
            }
        }

        return query;
    }

    $mix(mixins) {
        Blender.on(this).mix(mixins);

        return this;
    }

    list() {
        return this.transformer.many(
            this.try(
                this.baseQuery().select('id, title').get()
            )
        );
    }

    baseSearchQuery(relations, attributes, keywords) {
        const query = this.baseQuery();

        keywords = keywords.map(item => {
            return `%${item}%`;
        });

        relations.forEach(relation => {
            query.include(relation);
        });

        attributes.forEach((attribute, index) => {
            query[index > 0 ? 'orWhere' : 'where'](builder => {
                keywords.forEach((keyword, index) => {
                    builder[index > 0 ? 'orWhere' : 'where'](attribute, 'like', keyword);
                })
            });
        });

        return query;
    }
}

export default Repository;
